document.addEventListener("DOMContentLoaded", function () {
    // Pobierz dostępne kotwice z atrybutu data-available-anchors
    let availableAnchors = document.body.getAttribute("data-available-anchors");

    // Dodatkowe kotwice na sztywno
    const extraAnchors = "#kontakt-z-ekspertem, #contact-with-expert";

    // Dodaj dodatkowe kotwice do availableAnchors
    if (availableAnchors) {
        availableAnchors += ", " + extraAnchors;
    } else {
        availableAnchors = extraAnchors;
    }

    // Podziel string na tablicę
    const anchorsArray = availableAnchors.split(", ");

    // Pobierz aktualny hash z URL (z #)
    const currentHash = window.location.hash;

    // Sprawdź, czy hash występuje w tablicy kotwic
    if (anchorsArray.includes(currentHash)) {
        // Znajdź element o odpowiednim data-trigger (z #)
        const triggerElement = document.querySelector(`[data-trigger="${currentHash}"]`);
        
        if (triggerElement) {
            triggerElement.classList.add("cta-panels__panel--active");

            // Dodaj klasę do .bg-for-side-panels
            const bgElement = document.querySelector(".bg-for-side-panels");
            if (bgElement) {
                bgElement.classList.add("bg-for-side-panels--active");
            }
        }
    }
});

